import * as React from 'react';
import 'spring-picker/lib/style.css';
import * as SpringPicker from 'spring-picker';
import './index.scss'
import * as ReactDOM from 'react-dom';


interface initProps{
	visiblity?: any,
	data?: any,
	onConfrim ?: any,
	close?(): void,
	open?(): void,
	labelName ?: string, // name 别名
	valueLable?: string,  // value别名
	onChange?(value: string): void;
	changeState ?: void
}

class Picker extends React.Component <initProps , any> {

	constructor(props: any) {
		super(props);
		this.state = {
			result: [],
			visiblity: this.props.visiblity,
			onConfrim: '',
		    data: this.props.data,
		    labelName: '',
			valueLable: '', // value 数据 别名
			onChange: null // change 返回函数
		}
	}

	public close() {
		const body = (document as any).body;
		body.style.overflow = 'auto';

        this.setState({
            visiblity:false
        })
    }

    public open =(options?: any)=> {
		const body = (document as any).body;
		body.style.overflow = 'hidden';

        this.setState({
            visiblity: true,
            data: options.data ? options.data : [],
            onConfrim:  options.onConfrim ? options.onConfrim : '',
			valueLable: options.valueLable ? options.valueLable : '',
			labelName: options.labelName ? options.labelName : '',
			onChange: options.onChange
        })
    }

    public  changeState(data: any) {
		this.setState({
			result: data
		})
		return ;
	}

    componentDidMount() {
    }

    

	render() {
		return (
			<div>
				{
					this.state.visiblity ?
					<div className="dialog">
						<div className="mask"></div>
						<div className="picker">
							<div className="picker-title">
								<span className="cancel" onClick={() => this.close() }>取消</span>
								<span className="confrim" onClick={()=> this.confrim()}>确定</span>
							</div>
							<div className="picker-content">
								{

									this.state.data && this.state.data.map((v: any, k: any) => {
										return (
											<SpringPicker.Picker
											    data={v}
											    onChange={(r: any) => this.handleChangeUser(r,k)}
											    key={k}
											/>
										) 
									})
								}
							</div>
						</div>
					</div> : ''
				}
			</div>
		)
	}

	

	private handleChangeUser(r: any, index: any) {
	    const templte = this.state.result;
		if (this.state.onChange) {
			templte[index] = ((data: any) => {
				if(data && data.children) {
					return data
				}
			})(r)

			this.setState({
				result: templte
			});

			this.state.onChange(r, index, this.state.result);
		}else {

		    templte[index] = {...r};

			this.setState({
				result: templte
			});
		}
	}

	private confrim() {
		const that = this;
		this.setState({
            visiblity:false
        }, () => {
        	const body = (document as any).body;
			body.style.overflow = 'auto';
        	if(that.state.onConfrim) {
        		// 解析数据
    			const nameArr = that.state.result.map((v:any) => {
    				if(that.state.labelName && v) {
    					return v[that.state.labelName]
    				}
    				return v ? v.name :''
    			})
    			const valueArr = that.state.result.map((v:any) => {
    				if(that.state.valueLable && v) {
    					return v[that.state.valueLable]
    				}
    				return v ? v.value : ''
    			})
        		const result = {
        			arr: that.state.result,
        			nameArr: nameArr,
        			name: nameArr.join(''),
        			valueArr: valueArr,
        			value: valueArr.join('')
        		}
				that.state.onConfrim(result);
			}
        })

		
	}

}

let div = document.createElement('div');
document.body.appendChild(div);
let PickerBox = ReactDOM.render(<Picker /> ,div); 


export { Picker, PickerBox } ;
